import Paper from '@material-ui/core/Paper';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import Typography from '@serko/zui/es/Typography';
import React, { FunctionComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import messages from '../intl/messages';
import { AppState } from '../store/model';
import {
  getTravelArrangerName,
  getTravelArrangerNotes,
} from '../store/reducers/itinerary/selectors';
import { spacings } from './lab/spacings';

interface StateProps {
  arrangerName: string;
  notes: string;
}

interface ArrangerNotesProps
  extends StateProps,
    WithStyles<typeof styles>,
    InjectedIntlProps {}

const ArrangerNotesBase: FunctionComponent<ArrangerNotesProps> = ({
  arrangerName,
  classes,
  intl: { formatMessage },
  notes,
}) => {
  if (!arrangerName || !notes) return null;

  return (
    <Paper className={classes.container} square>
      <Typography inline>
        {formatMessage(messages.common.notesFromArranger, { arrangerName })}
      </Typography>
      <Typography inline className={classes.arrangerNote}>
        {notes}
      </Typography>
    </Paper>
  );
};

const mapStateToProps = (state: AppState): StateProps => {
  return {
    arrangerName: getTravelArrangerName(state),
    notes: getTravelArrangerNotes(state),
  };
};

// styled
const styles = (theme: Theme) => {
  const {
    paper: paperSpacing,
    between: {
      card: { card: cardSpacing },
    },
  } = spacings(theme);
  return createStyles({
    container: {
      ...paperSpacing,
      ...cardSpacing,
      display: 'block',
      textAlign: 'left',
    },
    arrangerNote: {
      fontStyle: 'italic',
    },
  });
};

/**
 * Notes from the travel arranger to travellers
 *
 * @example
 * "Notes from Jane:"
 * "There aren't many flight options remaining"
 */
export const ArrangerNotes = compose<ArrangerNotesProps, {}>(
  pure,
  connect(mapStateToProps),
  withStyles(styles),
  injectIntl,
)(ArrangerNotesBase);

ArrangerNotes.displayName = 'ArrangerNotes';
